import { useEffect, useState } from "react";
import Label from "../../../../components/new/inputs/Label";
import {
    TripSearchModel,
    TripSearchDropdownDefaultOptions,
    tripSearchSelectInputStyle,
    getAndSetCounterByCompany,
    getAndSetUsersByCounter,
    processStations,
    getStation,
    getToStations,
} from "../../helpers/top-navbar-helper";
import { userCompanyId, userCounterId } from "../../../../utility/helpers";
import CompanySelect from "../../../../components/CommonSelect/CompanySelect";
import CustomSelect from "../../../../components/new/inputs/Select";
import Button from "../../../../components/new/inputs/Button";
import GoodsManageModal from "../Modals/GoodsManageModal";
import Input from "../../../../components/new/inputs/input";
import { Calendar } from "primereact/calendar";
import { getStaions } from "../../../../services/counter/dashboard.service";
import BalanceChip from "../BalanceChip";
import { useToast } from "../../../../hooks/ToastContext";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
    setTripSearchData,
    setTriggerTripSearch,
    setResetTrips,
    setDepartureTimes,
    setIsCompanyCallCenterSearchDataChanged,
} from "../../../../store/counterPanelTripSearch";
import { getTimeStamp, getUserData } from "../../../../utility/utils";
import { twJoin } from "tailwind-merge";
import { getCounters } from "../../../../services/counter.service";
import dayjs from "dayjs";
import TripSearchSelect from "./TripSearchSelect";
import CounterUserBalanceChip from "../CounterUserBalanceChip";
import LazyLoadSelect from "../../../../components/new/inputs/LazyLoadSelect";

export default function TopNavbarTripSearch({
    currentUser,
    companyConfig = {},
}) {
    const { toast } = useToast();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const isCompanyUser = userCompanyId();
    const isCounterUser = userCounterId();
    const {
        tripSearch,
        departureTimes,
        travelMode,
        counterInfo,
        isLoading,
        isCompanyCallCenterSearchDataChanged,
    } = useSelector((state) => state.counterPanelTripSearch);

    const [formState, setFormState] = useState(TripSearchModel());
    const [minAllowedDay, setMinAllowedDay] = useState(new Date());
    const [maxAllowedDay, setMaxAllowedDay] = useState(new Date());
    const [searchOptions, setSearchOptions] = useState(
        TripSearchDropdownDefaultOptions
    );
    const [isGoodsManageModalOpen, setIsGoodsManageModalOpen] = useState(false);
    const [stickyClass, setStickyClass] = useState("");
    const [inputValue, setInputValue] = useState("");
    const [toValue, setToValue] = useState("");
    const [isCounterUserLoading, setIsCounterUserLoading] = useState(false);
    const [isStationLoading, setIsStationLoading] = useState(true);

    const loadDependency = async () => {
        try {
            const stationResponse = await getStaions();
            const fromStations = processStations(
                stationResponse.data.data ?? [],
                travelMode
            );
            setSearchOptions({ ...searchOptions, fromStations });
        } catch (e) {
            console.log(e);
        }
        setIsStationLoading(false);
    };

    const onTripNumberChange = (e) => {
        const value = e.target.value;

        setFormState({
            ...formState,
            tripNo: { value },
        });

        dispatch(setTripSearchData({ ...tripSearch, tripNo: value }));
    };

    const onDepartureDateChange = (value) => {
        // If user select same value again.
        if (value == formState.departureDate.value) return;

        setFormState({
            ...formState,
            departureDate: { value },
            departureTime: TripSearchModel().departureTime,
        });

        dispatch(setDepartureTimes([]));

        dispatch(
            setTripSearchData({
                ...tripSearch,
                departureDate: value,
                departureTime: null,
            })
        );
    };

    const onDepartureTimeChange = (option) => {
        // If user select same value again.
        if (option !== null && option?.value == formState.departureTime.value)
            return;

        //  If user select default/placeholder value.
        if (option === null) {
            option = TripSearchModel().departureTime;
        }

        setFormState({
            ...formState,
            departureTime: option,
        });

        dispatch(
            setTripSearchData({ ...tripSearch, departureTime: option.value })
        );
    };

    const onLeavingFromChange = (option) => {
        // If user select same value again.
        if (option.value == formState.from.value) return;

        const model = TripSearchModel();
        setFormState({
            ...formState,
            from: option,
            to: model.to,
            departureTime: model.departureTime,
        });

        setToStation(option);

        dispatch(
            setTripSearchData({
                ...tripSearch,
                from: option.originalId,
                to: null,
                departureTime: null,
            })
        );

        // dispatch(setResetTrips(getTimeStamp()));

        // If user change user while trips table already displayed.
        if (
            !isCompanyCallCenterSearchDataChanged &&
            (isCounterUser ||
                (!isCounterUser &&
                    formState.counterId.value &&
                    formState.counterUserId.value))
        ) {
            dispatch(setIsCompanyCallCenterSearchDataChanged(true));
        }
    };

    const onGoingToChange = (option) => {
        // If user select same value again.
        if (option.value == formState.to.value) return;

        setFormState({
            ...formState,
            to: option,
            departureTime: TripSearchModel().departureTime,
        });

        dispatch(
            setTripSearchData({
                ...tripSearch,
                to: option.originalId,
                departureTime: null,
            })
        );

        dispatch(setDepartureTimes([]));

        // dispatch(setResetTrips(getTimeStamp()));

        // If user change user while trips table already displayed.
        if (
            !isCompanyCallCenterSearchDataChanged &&
            (isCounterUser ||
                (!isCounterUser &&
                    formState.counterId.value &&
                    formState.counterUserId.value))
        ) {
            dispatch(setIsCompanyCallCenterSearchDataChanged(true));
        }
    };

    const onCompanyChange = (option) => {
        // If user select same value again.
        if (option.value == formState.companyId.value) return;

        const model = TripSearchModel();
        setFormState({
            ...formState,
            companyId: option,
            counterId: model.counterId,
            counterUserId: model.counterUserId,
            // from: model.from,
            // to: model.to,
            // departureTime: "",
        });

        dispatch(
            setTripSearchData({
                ...tripSearch,
                companyId: option.value,
                counterId: null,
                counterUserId: null,
                // from: null,
                // to: null,
                // departureTime: null,
            })
        );

        setSearchOptions({ ...searchOptions, counters: [], counterUsers: [] });

        getAndSetCounterByCompany(
            option.value,
            searchOptions,
            setSearchOptions
        );

        // dispatch(setDepartureTimes([]));
        // dispatch(setResetTrips(getTimeStamp()));

        // If user change user while trips table already displayed.
        dispatch(setIsCompanyCallCenterSearchDataChanged(true));
    };

    const onCounterChange = (option) => {
        // If user select same value again.
        if (option.value == formState.counterId.value) return;

        // if (tripSearch.counterUserId) dispatch(setResetTrips(getTimeStamp()));

        const model = TripSearchModel();

        setFormState({
            ...formState,
            counterId: option,
            counterUserId: model.counterUserId,
            // from: model.from,
            // to: model.to,
            // departureTime: "",
        });

        dispatch(
            setTripSearchData({
                ...tripSearch,
                counterId: option.value,
                counterUserId: null,
                // from: null,
                // to: null,
                // departureTime: null,
            })
        );

        setSearchOptions({ ...searchOptions, counterUsers: [] });

        getAndSetUsersByCounter(
            option.value,
            formState.companyId.value,
            searchOptions,
            setSearchOptions,
            setIsCounterUserLoading
        );

        // dispatch(setDepartureTimes([]));

        // If user change user while trips table already displayed.
        if (
            !isCompanyCallCenterSearchDataChanged &&
            formState.from.value &&
            formState.to.value
        ) {
            dispatch(setIsCompanyCallCenterSearchDataChanged(true));
        }
    };

    const onCounterUserChange = (option) => {
        // If user select same value again.
        if (option.value == formState.counterUserId.value) return;

        // const model = TripSearchModel();
        setFormState({
            ...formState,
            counterUserId: option,
            // from: model.from,
            // to: model.to,
            // departureTime: "",
        });

        dispatch(
            setTripSearchData({
                ...tripSearch,
                counterUserId: option.value,
                // from: null,
                // to: null,
                // departureTime: null,
            })
        );

        // dispatch(setDepartureTimes([]));
        // dispatch(setResetTrips(getTimeStamp()));

        // If user change user while trips table already displayed.
        if (
            !isCompanyCallCenterSearchDataChanged &&
            formState.from.value &&
            formState.to.value
        ) {
            dispatch(setIsCompanyCallCenterSearchDataChanged(true));
        }
    };

    const setToStation = (fromStation) => {
        let toStations = [];
        if (fromStation && fromStation.toStations.length) {
            toStations = getToStations(
                searchOptions.fromStations,
                fromStation.toStations,
                fromStation.value
            );
        }

        setSearchOptions({
            ...searchOptions,
            toStations,
        });

        dispatch(setDepartureTimes([]));
    };

    const setDefaultFromStation = () => {
        try {
            const fromStation = getStation(
                searchOptions.fromStations,
                counterInfo.station_id
            );

            if (fromStation) onLeavingFromChange(fromStation);
        } catch (e) {}
    };

    const onSearchBtnClick = async (isManualClick = false) => {
        if (
            (isCounterUser &&
                formState.from.value &&
                formState.to.value &&
                formState.departureDate.value) ||
            (!isCounterUser &&
                formState.counterId.value &&
                formState.counterUserId.value &&
                formState.from.value &&
                formState.to.value &&
                formState.departureDate.value)
        ) {
            dispatch(setIsCompanyCallCenterSearchDataChanged(null));
            const path = "counter-admin/counter-panel";
            if (location.pathname !== path) {
                navigate(path);
            }

            dispatch(
                setTripSearchData({
                    ...tripSearch,
                    fromType: formState.from.type,
                    toType: formState.to.type,
                })
            );

            dispatch(setTriggerTripSearch(getTimeStamp()));
        } else if (isManualClick) {
            let message = "Please select leaving from and going to.";
            if (
                !isCounterUser &&
                formState.from.value &&
                formState.to.value &&
                formState.departureDate.value &&
                (!formState.counterId.value || !formState.counterUserId.value)
            ) {
                message = "Please select counter and user.";
            }
            toast.error({ detail: message });
        }
    };

    useEffect(() => {
        if (travelMode) {
            loadDependency();

            // set initial departure date. Because it has default value.
            dispatch(
                setTripSearchData({
                    ...tripSearch,
                    departureDate: formState.departureDate.value,
                })
            );

            const { user } = getUserData();
            if (user?.metadata?.ticket_sale_previous_days) {
                const minAllowedDay = dayjs().subtract(
                    user?.metadata?.ticket_sale_previous_days,
                    "days"
                );
                setMinAllowedDay(minAllowedDay);
            }
            if (user?.metadata?.ticket_sale_next_days) {
                const maxAllowedDay = dayjs().add(
                    user?.metadata?.ticket_sale_next_days,
                    "days"
                );
                setMaxAllowedDay(maxAllowedDay);
            }
            if (
                !user?.metadata?.ticket_sale_previous_day &&
                !user?.metadata?.ticket_sale_next_days &&
                Object.keys(companyConfig).length
            ) {
                const minAllowedDay =
                    companyConfig?.find(
                        (item) => item.key === "past_trip_history"
                    )?.value || 0;
                const companyMaxAllowedDay = companyConfig?.find(
                    (item) => item.key === "ticket_availability_window"
                )?.value;
                const maxAllowedDay =
                    companyMaxAllowedDay >= 0 ? companyMaxAllowedDay : 30;
                setMinAllowedDay(dayjs().subtract(minAllowedDay, "days"));
                setMaxAllowedDay(dayjs().add(maxAllowedDay, "days"));
            }
        }
    }, [travelMode]);

    useEffect(() => {
        if (searchOptions.fromStations.length && counterInfo?.id) {
            setDefaultFromStation();
        }
    }, [searchOptions.fromStations, counterInfo]);

    useEffect(() => {
        onSearchBtnClick();
    }, [
        formState?.from?.value,
        formState?.to?.value,
        formState?.departureDate?.value,
        formState?.counterId?.value,
        formState?.counterUserId?.value,
    ]);

    const setSearchBarSticky = () => {
        if (window !== undefined) {
            let windowHeight = window.scrollY;
            windowHeight > 50
                ? setStickyClass("sticky top-0 left-0 z-50")
                : setStickyClass("");
        }
    };

    useEffect(() => {
        window.addEventListener("scroll", setSearchBarSticky);

        return () => {
            window.removeEventListener("scroll", setSearchBarSticky);
        };
    }, []);

    const phoneticFilter = (inputValue, options) => {
        let opt = [];
        const _opt = options?.filter((option) =>
            option.label.toLowerCase().includes(inputValue)
        );
        opt = [..._opt];
        if (!opt.length) {
            const count = {};
            for (const op of options) {
                count[op.label] = 0;
            }

            for (const iv of new Set(inputValue) || "") {
                for (const label of Object.keys(count)) {
                    if (label.toLowerCase().includes(iv)) {
                        count[label] = count[label] + 1;
                    }
                }
            }

            const temp = [];
            for (const key of Object.keys(count)) {
                temp.push({ [key]: count[key] });
            }

            let sortedCount = temp
                .sort((b, a) => a[Object.keys(a)[0]] - b[Object.keys(b)[0]])
                .slice(0, 10);
            sortedCount = sortedCount.map((a) => {
                const id = Object.keys(a)[0];
                return options.find(
                    (e) => e.label.toLowerCase() == id.toLowerCase()
                );
            });
            return sortedCount;
        }
        return opt;
    };

    const loadOptions = (inputValue, callback) => {
        setTimeout(() => {
            callback(phoneticFilter(inputValue, searchOptions.fromStations));
        });
    };

    const loadOptionsTo = (inputValue, callback) => {
        setTimeout(() => {
            callback(phoneticFilter(inputValue, searchOptions.toStations));
        });
    };

    return (
        <>
            <div
                className={twJoin(
                    "flex gap-2 items-center bg-[#008000] w-full px-2 pt-0 pb-1 max-lg:min-w-[930px] max-lg:flex-wrap",
                    stickyClass
                )}
            >
                <div className="mt-4">
                    <Button
                        className="h-[30px] bg-[#ffff00] text-black text-xs rounded-[3px] shadow-[0_0_5px_black] hover:!bg-[#ffff00] hover:text-black active:!bg-[#ffff00] visited:!bg-[#ffff00] focus:bg-[#ffff00]"
                        onClick={() => setIsGoodsManageModalOpen(true)}
                    >
                        Goods
                    </Button>
                </div>
                {!isCompanyUser ? (
                    <div className="flex flex-col z-30 w-[150px]">
                        <Label
                            htmlFor="search-company"
                            title="Company"
                            required={true}
                            className="max-lg:text-xs text-sm text-white"
                        />
                        <div className="flex flex-col">
                            <CompanySelect
                                inputId="search-company"
                                onChange={onCompanyChange}
                                value={formState.companyId}
                                styles={tripSearchSelectInputStyle}
                            />
                        </div>
                    </div>
                ) : null}
                <div className="flex flex-col w-[210px] flex-shrink-0 z-30">
                    <Label
                        htmlFor="search-from-station"
                        title="Leaving From"
                        required={true}
                        className="max-lg:text-xs text-sm text-white"
                    />
                    <TripSearchSelect
                        // options={searchOptions.fromStations}
                        inputId="search-from-station"
                        name="search-from-station"
                        onChange={onLeavingFromChange}
                        value={formState.from}
                        styles={tripSearchSelectInputStyle}
                        inputValue={inputValue}
                        onInputChange={(value) => setInputValue(value)}
                        defaultOptions={searchOptions.fromStations}
                        cacheOptions
                        loadOptions={loadOptions}
                        isLoading={isStationLoading}
                        // isDisabled={
                        //     !isCounterUser && !formState.counterUserId.value
                        // }
                    />
                </div>
                <div className="flex flex-col w-[210px] flex-shrink-0 z-30">
                    <Label
                        htmlFor="search-to-station"
                        title="Going To"
                        required={true}
                        className="max-lg:text-xs text-sm text-white"
                    />
                    <TripSearchSelect
                        // options={searchOptions.toStations}
                        inputId="search-to-station"
                        name="search-to-station"
                        onChange={onGoingToChange}
                        value={formState.to}
                        styles={tripSearchSelectInputStyle}
                        inputValue={toValue}
                        onInputChange={(value) => setToValue(value)}
                        defaultOptions={searchOptions.toStations}
                        cacheOptions
                        loadOptions={loadOptionsTo}
                        isLoading={isStationLoading}
                        isDisabled={!formState.from.value}
                    />
                </div>
                <div className="flex flex-col">
                    <Label
                        htmlFor="search-trip-no"
                        title="Trip No"
                        className="max-lg:text-xs text-sm text-white"
                    />
                    <div className="flex flex-col">
                        <Input
                            type="text"
                            id="search-trip-no"
                            name="search-trip-no"
                            onChange={onTripNumberChange}
                            value={formState.tripNo.value}
                            style={{
                                height: "30px",
                                fontSize: "14px",
                                minWidth: "100px",
                                width: "12vw",
                            }}
                            validation={false}
                            placeholder="Enter trip no."
                        />
                    </div>
                </div>
                <div className="flex flex-col w-[150px]">
                    <Label
                        htmlFor="search-departure-date"
                        title="Date"
                        className="max-lg:text-xs text-sm text-white"
                    />
                    <Calendar
                        disabled={isLoading}
                        id="search-departure-date"
                        value={new Date(formState.departureDate.value)}
                        dateFormat="dd/mm/yy"
                        onChange={(e) => {
                            const year = e.value?.getFullYear().toString();
                            const month = (e.value?.getMonth() + 1)
                                ?.toString()
                                ?.padStart(2, "0");
                            const date = e.value
                                ?.getDate()
                                ?.toString()
                                ?.padStart(2, "0");

                            const value = year + "-" + month + "-" + date;
                            onDepartureDateChange(value);
                        }}
                        style={{
                            height: "30px",
                            fontSize: "14px",
                            borderRadius: "!0px",
                        }}
                        inputClassName="!rounded-l !rounded-r"
                        selectOtherMonths={true}
                        minDate={new Date(minAllowedDay)}
                        maxDate={new Date(maxAllowedDay)}
                        readOnlyInput={true}
                    />
                </div>
                <div className="flex flex-col z-20 w-[150px]">
                    <Label
                        htmlFor="search-departure-time"
                        title="Time"
                        className="max-lg:text-xs text-sm text-white"
                    />
                    <CustomSelect
                        options={departureTimes}
                        inputId="search-departure-time"
                        name="search-departure-time"
                        onChange={onDepartureTimeChange}
                        value={formState.departureTime}
                        isClearable={
                            formState.departureTime.value ? true : false
                        }
                        styles={tripSearchSelectInputStyle}
                    />
                </div>
                {!isCounterUser ? (
                    <div className="flex flex-col z-20 w-[150px]">
                        <Label
                            htmlFor="search-counter"
                            title="Counter"
                            required={true}
                            className="max-lg:text-xs text-sm text-white"
                        />
                        <LazyLoadSelect
                            apiFunc={getCounters}
                            onChange={onCounterChange}
                            value={formState.counterId}
                            searchKey="title"
                            params={{
                                company: tripSearch.companyId,
                                order_by: "title",
                                direction: "ASC",
                            }}
                            initialLoad={true}
                            optionaLabel="title"
                            optionValue="id"
                            styles={tripSearchSelectInputStyle}
                        />
                    </div>
                ) : null}
                {!isCounterUser ? (
                    <div className="flex flex-col z-20 w-[200px]">
                        <div className="flex gap-x-1.5 items-center">
                            <Label
                                htmlFor="search-counter-user"
                                title="User"
                                required={true}
                                className="max-lg:text-xs text-sm text-white"
                            />
                            {!isCounterUser &&
                            formState.counterUserId.value &&
                            formState.counterUserId?.config?.is_prepaid ? (
                                <CounterUserBalanceChip
                                    userId={formState.counterUserId.value}
                                />
                            ) : null}
                        </div>
                        <CustomSelect
                            inputId="search-counter-user"
                            options={searchOptions.counterUsers}
                            onChange={onCounterUserChange}
                            value={formState.counterUserId}
                            styles={tripSearchSelectInputStyle}
                            disabled={!formState.counterId.value}
                            isLoading={isCounterUserLoading}
                        />
                    </div>
                ) : null}
                <Button
                    className="btn_search"
                    onClick={() => onSearchBtnClick(true)}
                >
                    Search
                </Button>
            </div>

            {/* prepaid user balance summary */}
            {currentUser?.config?.is_prepaid ? (
                <BalanceChip currentUser={currentUser} />
            ) : null}

            {isGoodsManageModalOpen ? (
                <GoodsManageModal
                    visible={isGoodsManageModalOpen}
                    setVisible={setIsGoodsManageModalOpen}
                    companyId={
                        isCompanyUser
                            ? isCompanyUser
                            : formState.companyId.value
                    }
                />
            ) : null}
        </>
    );
}
